
import React from "react";
import { Control } from "react-hook-form";
import { z } from "zod";
import { clientFormSchema } from "@/contexts/ProgramCreationContext";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";

type GoalsNotesFieldsProps = {
  control: Control<z.infer<typeof clientFormSchema>>;
};

export const GoalsNotesFields = ({ control }: GoalsNotesFieldsProps) => {
  return (
    <>
      <FormField
        control={control}
        name="goals"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Client Goals</FormLabel>
            <FormControl>
              <Textarea 
                className="bg-white/20 border-white/30 text-white min-h-[120px]"
                placeholder="What does the client want to achieve?"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white">Additional Notes</FormLabel>
            <FormControl>
              <Textarea 
                className="bg-white/20 border-white/30 text-white min-h-[120px]"
                placeholder="Any other important information about the client..."
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
